/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Canredirectcontacts2Inputs */

const en_entity_canredirectcontacts2 = /** @type {(inputs: Entity_Canredirectcontacts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can Redirect Contacts`)
};

const de_entity_canredirectcontacts2 = /** @type {(inputs: Entity_Canredirectcontacts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann Kontakte umleiten`)
};

/**
* | output |
* | --- |
* | "Can Redirect Contacts" |
*
* @param {Entity_Canredirectcontacts2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_canredirectcontacts2 = /** @type {((inputs?: Entity_Canredirectcontacts2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Canredirectcontacts2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_canredirectcontacts2(inputs)
	return de_entity_canredirectcontacts2(inputs)
});
export { entity_canredirectcontacts2 as "entity_canRedirectContacts" }